module.exports = __webpack_public_path__ + "static/media/facebook.073d304e.svg";